import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setGroupToEditReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.groupToEdit = action.payload;
  });
};

export default setGroupToEditReducer;
